import axios from 'axios';

const API = axios.create({ baseURL: '/api' });

API.interceptors.request.use((config) => {
  const token = localStorage.getItem('hrm_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

API.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('hrm_token');
      localStorage.removeItem('hrm_user');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

export const authAPI = {
  login: (email, password) => API.post('/auth/login', { email, password }),
  me: () => API.get('/auth/me'),
};

export const employeeAPI = {
  list: (params) => API.get('/employees', { params }),
  get: (id) => API.get(`/employees/${id}`),
  create: (data) => API.post('/employees', data),
  update: (id, data) => API.put(`/employees/${id}`, data),
  delete: (id) => API.delete(`/employees/${id}`),
  stats: () => API.get('/employees/stats'),
  departments: () => API.get('/employees/departments'),
};

export const attendanceAPI = {
  monthly: (empId, month) => API.get(`/attendance/${empId}`, { params: { month } }),
  teamToday: () => API.get('/attendance/team-today'),
  summary: (month) => API.get('/attendance/summary', { params: { month } }),
  checkIn: (method) => API.post('/attendance/check-in', { method }),
  checkOut: () => API.post('/attendance/check-out'),
};

export const leaveAPI = {
  list: (params) => API.get('/leave', { params }),
  balance: (empId, year) => API.get(`/leave/balance/${empId || ''}`, { params: { year } }),
  create: (data) => API.post('/leave', data),
  action: (id, status) => API.put(`/leave/${id}/action`, { status }),
};

export const payrollAPI = {
  list: () => API.get('/payroll'),
  get: (id) => API.get(`/payroll/${id}`),
  calculate: (period) => API.post('/payroll/calculate', { period }),
  approve: (id) => API.put(`/payroll/${id}/approve`),
  payslip: (runId, empId) => API.get(`/payroll/${runId}/payslip/${empId}`),
};

export const positionAPI = {
  list: () => API.get('/positions'),
  create: (data) => API.post('/positions', data),
  update: (id, data) => API.put(`/positions/${id}`, data),
  delete: (id) => API.delete(`/positions/${id}`),
};

export const departmentAPI = {
  list: () => API.get('/departments'),
  create: (data) => API.post('/departments', data),
  update: (id, data) => API.put(`/departments/${id}`, data),
  delete: (id) => API.delete(`/departments/${id}`),
};

export const userAPI = {
  list: () => API.get('/users'),
  create: (data) => API.post('/users', data),
  updateRole: (id, role) => API.put(`/users/${id}/role`, { role }),
  toggleActive: (id) => API.put(`/users/${id}/toggle`),
  resetPassword: (id, new_password) => API.put(`/users/${id}/reset-password`, { new_password }),
};

export const dailyTaskAPI = {
  summary: (date) => API.get('/daily-tasks/summary', { params: { date } }),
  logs: (params) => API.get('/daily-tasks/logs', { params }),
  updateLog: (logId, data) => API.patch(`/daily-tasks/logs/${logId}`, data),
  listDefinitions: (params) => API.get('/daily-tasks', { params }),
  createDefinition: (data) => API.post('/daily-tasks', data),
  updateDefinition: (id, data) => API.put(`/daily-tasks/${id}`, data),
  deleteDefinition: (id) => API.delete(`/daily-tasks/${id}`),
};

export const campaignAPI = {
  list: (params) => API.get('/campaigns', { params }),
  get: (id) => API.get(`/campaigns/${id}`),
  create: (data) => API.post('/campaigns', data),
  update: (id, data) => API.put(`/campaigns/${id}`, data),
  delete: (id) => API.delete(`/campaigns/${id}`),
};

export const dashboardAPI = {
  get: () => API.get('/dashboard'),
};

export const reportAPI = {
  weekly:  (date)  => API.get('/reports/weekly',  { params: { date } }),
  monthly: (month) => API.get('/reports/monthly', { params: { month } }),
};

export default API;
